import { createAction } from '@ngrx/store';

export const rootFeatureKey = 'Root';

const appInitialized = createAction(`[${rootFeatureKey}] App Initialized`);

export const RootActions = {
  appInitialized,
};
